const globalVariables = {
    // Local Backend (C:\xampp\htdocs\carp_aspire)
    // api_url: 'http://localhost/carp_aspire/public/index.php',
    // img_url: 'http://localhost/carp_aspire/public',
    // image_url: 'http://localhost/carp_aspire/public/',

    // Remote Server (Backup)
    api_url: 'https://carparise-api.archeparchybookkeeping.org/index.php',
    img_url: 'https://carparise-api.archeparchybookkeeping.org',
    image_url: 'https://carparise-api.archeparchybookkeeping.org/',
};

export default globalVariables;
